import React, { useEffect, useRef, useState } from 'react'
import {
  GridIcon,
  SettingsIcon,
  UniversityIcon,
  CoursesIcon,
  SpecializationIcon,
  InquiresIcon,
  StudentSectionIcon,
  PlacementIcon,
  ActivityLogsIcon,
} from '../icons'
import { Tooltip } from '@mui/material'

const sidebarMenu = [
  { label: 'Student Panel', isTitle: true },
  // { label: 'Dashboard', icon: <GridIcon className="nav-icon" />, href: '/user/' },
  { label: 'University', icon: <UniversityIcon className="nav-icon" />, href: '/user/university-review' },
  { label: 'Courses', icon: <CoursesIcon className="nav-icon" />, href: '/user/course-review' },
  { label: 'Specialization', icon: <SpecializationIcon className="nav-icon" />, href: '/user/specialization-review' },
]

const UserSidebar = () => {
  const sidebarRef = useRef(null)
  const [isActive, setIsActive] = useState(false)

  // Check if .sidebar has 'active' class
  useEffect(() => {
    const observer = new MutationObserver(() => {
      const isSidebarActive = sidebarRef.current?.classList.contains('active')
      setIsActive(isSidebarActive)
    })

    if (sidebarRef.current) {
      observer.observe(sidebarRef.current, { attributes: true, attributeFilter: ['class'] })
    }

    return () => observer.disconnect()
  }, [])

  return (
    <aside ref={sidebarRef} className="sidebar">
      <button type="button" className="sidebar-close-btn">
        <span className="icon">×</span>
      </button>

      <div>
        <a href="/" className="sidebar-logo">
          <img src="/assets/images/logo/logo.svg" alt="site logo" className="light-logo" />
          <img src="/assets/images/logo/logo.svg" alt="site logo" className="dark-logo" />
          <img src="/assets/images/logo/logo-icon.svg" alt="site logo" className="logo-icon" width={30} height={30} />
        </a>
      </div>

      <div className="sidebar-menu-area">
        <ul className="sidebar-menu" id="sidebar-menu">
          {sidebarMenu.map((item, index) =>
            item.isTitle ? (
              <li key={index} className="sidebar-menu-group-title">
                {item.label}
              </li>
            ) : (
              <li key={index} className={item.submenu ? 'dropdown' : ''}>
                {item.submenu ? (
                  <>
                    <a className="gap-2" onClick={(e) => e.preventDefault()}>
                      {isActive ? (
                        <Tooltip title={item.label} placement="right" arrow>
                          <span className="nav-icon-wrapper">{item.icon}</span>
                        </Tooltip>
                      ) : (
                        <span className="nav-icon-wrapper">{item.icon}</span>
                      )}
                      <span>{item.label}</span>
                    </a>
                    <ul className="sidebar-submenu">
                      {item.submenu.map((subItem, subIndex) => (
                        <li key={subIndex}>
                          <a href={subItem.href}>
                            <i className={`ri-circle-fill circle-icon ${subItem.iconClass} w-auto`} />
                            {subItem.label}
                          </a>
                        </li>
                      ))}
                    </ul>
                  </>
                ) : (
                  <a href={item.href} className="d-flex gap-2 align-items-center">
                    {isActive ? (
                      <Tooltip title={item.label} placement="right" arrow>
                        <span className="nav-icon-wrapper">{item.icon}</span>
                      </Tooltip>
                    ) : (
                      <span className="nav-icon-wrapper">{item.icon}</span>
                    )}
                    <span>{item.label}</span>
                  </a>
                )}
              </li>
            )
          )}
        </ul>
      </div>
    </aside>
  )
}

export default UserSidebar
